export default {
    message: {
        'header': {
            'online': 'en línea'
        },
        'footer': {
            'home': 'Casa',
            'points': 'Puntos',
            'vip_zone': 'VIP Zona',
            'order': 'Orden',
            'account': 'Cuenta'
        },
        'index': {
            'notice1': "Felicitaciones al jugador",
            'notice2': "'s participación, ganada",
            'notice3': "Vamos a felicitarle!",
            'hot_spot': 'Punto caliente',
            'all_goods': 'Todas las mercancías',
            'promotion_type': 'Tipo de Promoción',
            'partners': 'Socios',
            'announcement': 'El anuncio',
            'cancel': 'Cancelar',
            'travel_to': 'Para viajar a',
            'ok': 'OK'
        },
        'goods': {
            'name1': 'Doble reembolso ',
            'name2': 'Efectivo x2 devoluciones',
            'name3': 'Reembolso de 70 veces (VIP1)',
            'name4': 'Efectivo x72 devoluciones'
        },
        'img': {
            'banner1': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/b1e3c2a662e7333346ef1446db67b4c4.jpeg',
            'banner2': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/c9bf70863920f2a2ac53de21510d71c0.jpeg',
            'banner3': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/069a377136fa1234618c073b166f7ddd.jpeg',
            'banner4': 'https://manage.im2015.com//uploads/attach/2020/03/20200307/4a31597de7b1cc2674314bd8644415f2.jpg',
            'goods_img_10': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/a416c1aa63c2ca77eefa6cd89f376fc0.jpeg',
            'goods_img_50': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5ecd1c7981b5a4b58aed1e761e388ec7.jpeg',
            'goods_img_5': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/91e6995aeab9e5642b09289981288bd5.jpeg',
            'goods_img_150': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/1d5e4e5c3f6cb2e75a773f2c4bfaf014.jpeg',
            'goods_img_25': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/86d508dec4193df34ca3d10ec08eca8b.jpeg',
            'goods_img_500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/81f89dadca780f51c92416a95ee3328c.jpeg',
            'goods_img_1500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/69a61a0dfd4998c560b96500d41f9c5f.jpeg',
            'goods_img_2500': 'https://zhouyaoming.in2015.com//uploads/attach/2021/10/20211015/5f47a07b067b6e3acc27a1e384572a69.jpeg',
            'goods_img_return': 'https://zhouyaoming.in2015.com//uploads/attach/2021/06/20210615/f5c725953f90a25e5111bd5b14d4952f.png'
        },
        'detail': {
            'please_select': 'Por favor seleccione',
            'product_description': 'Descripción del producto',
            'check_out': 'Verificar',
            'original_price': 'Precio original',
            'inventory': 'Inventario',
            'sold': 'Vendido',
            'tip_start': 'El éxito de la promoción se puede elevar a bienes valorados en ',
            'tip_end': ' Moneda de forma gratuita',
            'quantity': 'cantidad',
            'total_price': 'Precio total',
            'win_rate': 'Tasa de ganancia',
            'predict_type': 'Tipo de predicción ',
            'member_shared': 'Miembros compartidos recibirán',
            'share_now': 'Compartir ahora',
            'copy_the_link': 'Copiar el enlace',
            'send_to_friend': 'Enviar a un amigo',
            'copy_success': 'Éxito de copia',
            'copy_error': 'Error de copia'
        },
        'integral': {
            'title': 'Zona de intercambio de puntos',
            'search': 'Busca información sobre el producto»',
            'points': 'Puntos'
        },
        'vip_zone': {
            'title': 'VIP Lista de artículos',
            'price': 'Precio',
            'sales_volume': 'Volumen de ventas'
        },
        'login': {
            'account_login': ['Cuenta de Ingreso'],
            'login': 'Ingresar',
            'phone': 'Introduzca su número de teléfono',
            'pwd': 'Rellene su contraseña',
            'no_account': '¿Tiene una cuenta existente?',
            'forgot_password': 'Olvida contraseña',
            'register': 'Registrar'
        },
        'reset_pwd': {
            'title': 'Recuperar contraseña',
            'get_verification_code': 'Obtener código de verificación',
            'confirm': 'Confirmar',
            'verification_code': 'Código de verificación',
            'your_new_pwd': 'Tu nueva contraseña',
            'reload': 'Recargar',
            'msg_phone': 'Por favor, introduzca su número de teléfono'
        },
        'register': {
            'register_account': 'Cuenta de Registro',
            'account': 'Número de teléfono',
            'pwd': 'Contraseña de acceso',
            'con_pwd': 'Confirmar contraseña',
            'register': 'registrar',
            'tip_account': '¿Tiene una cuenta existente?',
            'by_click': 'Haciendo clic en "Registrar" estoy de acuerdo con el centro comercial interesante',
            'privacy_policy': 'Política de Privacidad',
            'tip_wrong': '* El número de teléfono móvil incorrecto no podrá utilizar el sitio web normalmente.',
            'msg_phone': 'El error de formato del teléfono'
        },
        'order': {
            'submit_order': 'Enviar orden',
            'item': 'Artículo',
            'payment_method': 'Método de pago',
            'pay_via_balance': 'Pagar via saldo',
            'balance_available': 'Saldo disponible',
            'total_price': 'Precio total',
            'total': 'Total',
            'check_out': 'Verificar',
            'msg_param': 'El parámetro está incorrecto',
            'msg_order_field': 'Error al cargar los datos de pedido',
            'msg_select_payment': 'Por favor, seleccione el método de pago',
            'tip_create_order': 'Crear de orden ...',
            'PAGEN_SUCTEDED': 'Éxito del pago',
            'PAGO_FAIL': 'Fallo del pago',
            'Order_no': 'Pagar ahora',
            'Order_time': 'Tiempo de pedido',
            'other': 'Otro',
            'total_amount': 'Importe Total',
            'failure_reason': 'Razón de fallo',
            'view_payment_results': 'Ver resultados de pago',
            'payment_failed_to_repay': 'El pago no puede pagar',
            'top_up': 'recargar',
            'hot_spot': 'PUNTO CALIENTE',
            'back_home': 'Volver a casa',
            'msg_create_success': 'Orden creado con éxito',
            'confirm_title': 'pagar',
            'confirm_msg': 'Error del pago,',
            'confirm_cancel': 'Cancelar',
            'confirm_top_up': 'recargar',
            'game_odd': 'Impar',
            'game_even': 'Par',
            'game_title': 'IMPAR O PAR',
            'game_select_title': 'Seleccione su resultado anticipado',
            'game_odd_number': 'Número impar',
            'game_even_number': 'Número par',
            'game_confirm_selection': 'Confirmar selección',
            'game_opening_time': 'Tiempo de apertura',
            'game_issue': 'Problema',
            'game_number': 'Número',
            'game_results': 'Resultados',
            'game_submit_err': 'Error: ¡ID de pedido no existe!',
            'game_choose_least': '¡Por favor elija al menos uno!',
            'game_success': 'Éxito',
            'game_error': 'Error',
            'game_confirm': 'Confirmar',
            'game_confirm_title': 'Mensaje',
            'game_confirm_msg': '¿Estás seguro de seleccionar este?',
            'game_confirm_cancel': 'cancelar',
            'chart': 'Gráfico',
            'close': 'Cerrar',
            'bulls_eye': 'TOROS-OJOS',
            'trend_recent': 'Tendencia de los últimos 50 períodos',
            'number': 'Número',
            'times_without': 'Tiempos sin',
            'bet': 'Apuesta'
        },
        'my_order': {
            'title': 'Mi orden',
            'operated': 'operado',
            'receive': 'Recibir',
            'completed': 'Completado',
            'converted': 'Convertido',
            'refund': 'Reembolso',
            'item_total_amount': 'Artículo, Importe total',
            'picking_up': 'Recogiendo',
            'redeem_points': 'Redime puntos',
            'processing_pick_up': 'Procesamiento para recoger',
            'hot_spot': 'PUNTO CALIENTE',
            'view_details': 'Ver detalles',
            'check_tracking': 'Comprobar la información de seguimiento',
            'confirm_receival': 'Confirmar receptores',
            'receipt': 'Recibo',
            'cancel': 'Cancelar',
            'confirm_pick_up': 'Confirmar recogida',
            'not_sales': 'Todavía no está en venta',
            'sales_failed': 'Ventas fallidas',
            'sales_success': 'Éxito de ventas',
            'waiting_draw': 'Esperando para dibujar',
            'bonus_countdown': 'Cuenta regresiva de bonificación',
            'redeem_success': 'Redime éxito',
            'awarded': 'Galardonado',
            'points': 'puntos',
            'fee': 'Tasa',
            'cash': 'effectivo',
            'sure': 'seguro',
            'detail_title': 'Detalles de orden',
            'detail_copy': 'Copia',
            'detail_order_no': 'Número del orden',
            'detail_order_time': 'Tiempo de pedido',
            'detail_type_order': 'Tipo de orden',
            'detail_status_payment': 'Estado de pago',
            'detail_have_pay': 'Tienes que pagar',
            'detail_did_pay': 'No paga',
            'detail_promotion_status': 'Estado de promoción',
            'detail_promotion_period': 'Período de promoción',
            'detail_promotion_games': 'Juegos de promoción',
            'detail_opening_time': 'Tiempo de apertura',
            'detail_my_choice': 'Mi elección',
            'detail_lottery_numbers': 'Números de lotería',
            'detail_payment_method': 'Método de pago',
            'detail_total_amount': 'Importe Total',
            'detail_amount_paid': 'Importe pagado',
            'detail_re_order': 'Re-pedir'
        },
        'user': {
            'account': 'Cuenta',
            'available_balance': 'Saldo disponible',
            'my_points': 'Mis puntos',
            'active_code': 'Código Activo',
            'your_code': 'Introduzca su código',
            'msg_code': 'Rellene el código de cambio',
            'ok': 'OK',
            'deposit': 'Depósito',
            'withdraw': 'Retirar',
            'confirm_title': '¿Confirmar el cambio?',
            'confirm_msg': 'Cambio de avatar del usuario',
            'confirm_cancel': 'Cancelar',
            'confirm_ok': 'Confirmar',
            'cancelled': 'Cancelado',
            'profile_title': 'Perfil de usuario',
            'profile_manage_account': 'Administre mi cuenta',
            'profile_nickname': 'Apodo',
            'profile_real_name': 'Nombre real',
            'profile_email': 'Correo electrónico',
            'profile_phone': 'Teléfono',
            'profile_password': 'Contraseña',
            'profile_click_change_password': 'Haga clic en cambiar contraseña',
            'profile_save_the_change': 'Guardar el cambio',
            'profile_log_out': 'Cerrar sesión',
            'profile_confirm_title': 'Cerrar sesión',
            'profile_confirm_msg': 'Confirmar cierre de sesión?',
            'profile_confirm_cancel': 'Cancelar',
            'profile_confirm': 'Confirmar',
            'change_password_title': 'Cambiar contraseña',
            'change_password_current_pwd': 'Introduzca su contraseña actual',
            'change_password_set_new_pwd': 'Configurar tu nueva contraseña',
            'change_password_confirm_new_pwd': 'Confirmar nueva contraseña',
            'change_password_confirm_change': 'Confirmar el cambio',
            'change_password_msg_current_pwd': 'Por favor, introduzca la contraseña actual',
            'change_password_msg_new_pwd': 'Por favor, introduzca una nueva contraseña',
            'change_password_msg_new_pwd_again': 'Por favor introduzca nueva contraseña de nuevo',
            'change_password_msg_not_match': 'Contraseña no₫cide',
            'user_rank_title': 'Registro de apertura del premio',
            'user_menu_bulletin': 'Anuncio',
            'user_menu_vip': 'VIP',
            'user_menu_binance_pay': 'Pago de Binance',
            'user_menu_agent': 'Agente',
            'user_menu_balance_details': 'Detalles del saldo',
            'user_menu_lottery_record': 'Registro de Lotería',
            'user_menu_service': 'Servicio',
            'user_menu_about_us': 'Acerca de nosotros'
        },
        'balance_detail': {
            'title': 'Detalles del saldo',
            'total_amount': 'Importe total',
            'top_up': 'Recargar',
            'accumulated_withdrawal': 'Retirado acumulado',
            'bill_record': 'Registro de facturas',
            'consumption_records': 'Registros de consumo',
            'recharge_records': 'Registros de recargar',
            'points_center': 'Centro de puntos',
            'sign_in': 'Inicia sesión para recoger puntos.',
            'upgrade_level': '¡Mejora de los niveles para desbloquear más jugadas!'
        },
        'my_pay': {
            'title': 'Enlace e - cartera',
            'phone': 'Teléfono',
            'phone_plac': 'Entra tu teléfono',
            'binance_id': 'Binance ID',
            'binance_id_plac': 'Entra Binance ID',
            'pay_nickname': 'Sobrenombre de paga',
            'pay_id': 'ID del pago',
            'pay_id_plac': 'Introduzca el ID de pago',
            'tip': 'Por favor, asegúrese de que toda la información es correcta, de lo contrario no podrá retirarse.',
            'bind': 'Atar',
            'edit': 'Editar',
            'msg_nickname': 'Por favor introduzca el apodo de Pago',
            'confirm_msg': "<b style='color: red'>Nota</b>: El apodo de pago sólo se puede modificar una vez ! ! !<br>Apodo de pago:",
            'confirm_title': 'Editar Binance Apodo del Pago',
            'confirm_cancel': 'Cancelar',
            'confirm_cancelled': 'Cancelado',
            'confirm_confirm': 'Confirmar',
            'msg_phone': 'Por favor introduzca el número de teléfono',
            'msg_binance_id': 'Por favor, introduzca el ID de Binance',
            'msg_binance_id_format': 'Error de formato de identificación Binance',
            'msg_pay_nickname': 'Por favor introduzca el apodo de pago',
            'msg_pay_id': 'Por favor introduzca el ID de pago',
            'msg_pay_id_format': 'Error de formato de ID de pago',
            'msg_pay_id_length': 'Error de longuitud de ID de pago',
            'msg_binance_pay': 'Id de Binance no es ID de pago, se puede encontrar ID de pago en la página de recepción.',
            'msg_confirm_title': 'Información de confirmación del pago de Binance',
            'msg_confirm_msg1': 'Tu apodo de Pago',
            'msg_confirm_msg2': 'Tu ID de pago',
            'msg_confirm_msg3': 'Nota: Una vez confirmada, no puede ser desencadenada!',
            'msg_confirm_cancel': 'Cancelar',
            'msg_confirm_cancelled': 'Cancelado',
            'msg_confirm': 'Confirmar',
            'bind_success_msg': 'Enlace éxito, obtienes'
        },
        'user_bill': {
            'title': 'Detalles del saldo',
            'all': 'Todos',
            'consumption': 'Consumo',
            'recharge': 'Recarga',
            'income': 'Ingreso'
        },
        'user_integral': {
            'title': 'Detalles de puntos',
            'current_points': 'Puntos actuales',
            'accumulated_points': 'Puntos acumulados',
            'accumulated_consumption': 'Consumo acumulado',
            'obtained_today': 'Obtenido hoy',
            'details_points': 'Detalles de puntos',
            'increase_points': 'Puntos de aumento',
            'points_rewarded_purchasing': 'Puntos recompensados por compra',
            'earn_points': 'Gana puntos',
            'points_rewarded_sign': 'Puntos recompensados por signos diarios',
            'sign_points': 'Puntos',
            'sign_details': 'Detalles',
            'sign_signed': 'Firmado',
            'sign_sign': 'Firmar',
            'sign_accumulated_sign': 'Signo acumulado en',
            'sign_days': 'días',
            'sign_tip2_s': 'Se dice que el',
            'sign_tip2_e': ' El día de la entrada continua tendrá grandes puntos recompensados, no te olvides de firmar en  ~~~',
            'sign_click_load_more': 'Haga clic para cargar más',
            'sign_success': 'Firme en con éxito',
            'sign_awarded': 'Galardonado',
            'sign_sure': 'seguro',
            'sign_cnum': ["cero", "uno", "dos", "tres", "cuatro", "cinco", "seis", "siete", "ocho", "nueve"],
            'sign_msg_signed': '¡Has firmado hoy!',
            'detail_title': 'Orden de puntos',
            'detail_phone': 'Teléfono',
            'detail_payment_method': 'Método de pago',
            'detail_pay_with_points': 'Pagar con puntos',
            'detail_available_points': 'Puntos disponibles',
            'detail_total': 'Total',
            'detail_points': 'Puntos',
            'detail_check_out': 'Verificar',
            'pay_points': 'Pagar los puntos',
            'detail_parameter_wrong': 'El parámetro es incorrecto',
            'detail_failed_data': 'Fallo de carga de los datos del pedido',
            'detail_creating_order': 'Creando orden...',
            'detail_creating_order_fail': 'Fallo de creación de órden',
            'detail_status_title': 'Intercambio exitoso de mercancías',
            'detail_status_check_mailbox': 'Por favor, marque su buzón, entregaremos el producto dentro de 24 horas.',
            'detail_status_view_order': 'Ver el orden',
            'detail_status_back_home': 'Volver a casa',
            'detail_points_title': 'Detalles de puntos',
            'my_order_points_title': 'Mis puntos de orden'
        },
        'recharge': {
            'title': 'Enviar una solicitud completa',
            'first_deposit': 'Bono de primer depósito',
            'use_binance': 'Binance Uso',
            'choose_amount': 'Por favor, elija el importe y continúe',
            'current_balance': 'Nota: saldo corriente',
            'confirm_top_up': 'Confirmar la recarga',
            'application_details': 'Recargar los detalles de la aplicación',
            'order_number': 'Número de orden',
            'application_time': 'Tiempo de solicitud',
            'top_up_amount': 'Importe de recarga',
            'top_up_status': 'Estado de recarga',
            'reviewing': 'Revisión',
            'application_success': 'Éxito de aplicación',
            'application_failed': 'Fallo de aplicación',
            'msg_bind_binance': 'Por favor vincule Binance Pago',
            'msg_minimum_bank': 'Mínimo 100 a recargar',
            'msg_minimum_binance': 'Mínimo 1 a recargar',
            'msg_enter_top_up_amount': 'Por favor ingrese la cantidad de recarga',
            'confirm_title': 'Confirmar los detalles del depósito',
            'confirm_verify_information': 'Por favor verifique la información',
            'confirm_tip': 'Envíe dinero a cualquiera de las siguientes cuentas utilizando el pago de Binance enlazado, haga clic en la esquina superior derecha para ver el tutorial.',
            'confirm_our_pay_id': 'Nuestro ID de pago',
            'confirm_copy': 'Copiar',
            'confirm_top_up_amount': 'Importe recargado',
            'confirm_confirm_top_up': 'Confirmar la recarga',
            'confirm_msg_copy': 'Éxito de copia',
            'confirm_msg_enter_amount': 'Introduzca el importe para recargar',
            'confirm_transfer_amount': 'Importe de transferencia mínimo de 1',
            'confirm_alert_mes': 'Confírmese que el pago de la Binance obligada se ha utilizado para pagarnos..<b style=\'color: red\'> Por favor, espere 5-10 minutos en llegar.</b>Si tiene alguna pregunta, por favor póngase en contacto con el servicio al cliente a tiempo.',
            'confirm_alert_title': 'Enviar la aplicación de recargar',
            'confirm_alert_cancel': 'Cancelar',
            'confirm_alert_msg_cancelled': 'Cancelado',
            'confirm_alert_confirm': 'Confirmar'
        },
        'withdrawal': {
            'title': 'Retirar',
            'link_now_tip': 'Usted no tiene enlace e-cartera todavía, por favor enlace y enviar la solicitud de retirada de nuevo.',
            'link_now': 'Enlace ahora',
            'withdrawal_account': 'Cuenta de retirada',
            'phone': 'Teléfono',
            'binance_id': 'Binance ID',
            'nickname': 'Apodo',
            'pay_id': 'ID de Pago',
            'withdraw_amount': 'Importe de Retirada',
            'balance': 'Saldo',
            'processing_fee': 'Tasa de transformación',
            'actual_amount': 'Importe actual',
            'msg_withdrawal_account': 'Seleccione la cuenta de retirada',
            'msg_fill_data': 'Rellene los datos',
            'msg_phone': 'Por favor introduzca el número de teléfono',
            'msg_binance_id': 'Por favor, introduzca el ID de Binance',
            'msg_binance_pay_id': 'Por favor, introduzca ID de pago de Binance',
            'msg_pay_id_err': 'Error de formato de ID de pago',
            'msg_withdraw_amount': 'Introduzca el importe de retirada',
            'msg_insufficient_balance': 'Saldo insuficiente',
            'msg_mini_withdraw': 'Mínimo 160 a retirar',
            'msg_minimum': 'Mínimo ',
            'msg_to_withdraw': 'Retirar',
            'audit_tip': 'Se ha presentado la retirada, a la espera de la revisión',
            'audit_sure': 'seguro'
        },
        'user_vip': {
            'title': 'Centro de miembro',
            'able_purchase': 'Posible de comprar artículo en',
            'off': 'apagado',
            'level_task1': 'Completar el Depósito de 1USD y comprar bienes 50 veces para convertirse en VIP!!',
            'level_task2': 'Tasa de retirada',
            'level_task3': 'Tiempo de retirada',
            'level_task4': 'H',
            'vip_level_unlocked': 'VIP nivel desbloqueado',
            'higher_level_unlocked': 'Nivel superior desbloqueado',
            'vip_upgrade_requirements': 'VIP requisitos de actualización',
            'required_tasks': 'Tareas requeridas',
            'select_one_below': 'Por favor seleccione uno de abajo',
            'achieved': 'conseguido',
            'conditions_met': 'condiciones no cumplidas',
            'accumulated_participation': 'Participación acumulada en el juego',
            'achieved_top_up': 'acumulado 50 monedas a recargar',
            'exclusive_coupons': 'Cupones exclusivos',
            'more_games': 'Más juegos',
            'need_recharge': 'Necesita a recargar 50 monedas'
        },
        'promoter': {
            'title': 'Gestión del promotor',
            'apply_agency': 'Solicitar una agencia y convertirse en uno de nosotros',
            'become_agent': 'Convertirse en agente»',
            'repeatedly_delayed': 'Subir puede retrasarse, por favor espere un rato y no haga clic repetidamente!',
            'current_commission': 'Comisión actual',
            'record': 'registrosl',
            'profit_yesterday': 'Ganancia ayer',
            'accumulated_withdrawal': 'Retirado acumulado',
            'withdraw': 'Retirar',
            'refer_friends': 'Referir amigos',
            'total_agent': 'Total agente',
            'copy_success': 'Éxito de copia',
            'copy_error': 'Error de copia',
            'promoter_achievements': 'Logros promotores',
            'promoter_orders': 'Ordenes promotoras',
            'promoter_ranking': 'Clasificación del promotor',
            'commission_ranking': 'Clasificación de comisión',
            'list_title': 'Número de agentes',
            'list_number_agents': 'Número de agentes',
            'list_people': 'gente',
            'list_date_joined': 'Fecha unida',
            'list_item': 'artículo',
            'order_title': 'Ordenes acumuladas',
            'order_accumulated_orders': 'Ordenes acumuladas',
            'order_commission': 'comisión',
            'order_time': 'Tiempo de pedido',
            'order_mark': 'marca',
            'commission_title': 'Logros Promotores',
            'commission_accumulated_commission': 'comisión acumulada',
            'commission_available': 'Comisión disponible para la retirada',
            'commission_week': 'Nuevos miembros esta semana',
            'commission_month': 'Nuevos miembros este mes',
            'commission_achievement': 'Logros',
            'commission_rank_title': 'Clasificación de comisión',
            'commission_rank_current': 'Su clasificación actual',
            'commission_rank_yet': 'Aún no estás en la clasificación.',
            'rank_title': 'Clasificación  promotora',
            'cash_record_title': 'Detalles de retirada de comisión',
            'cash_record_cash_out': 'Récord de retiro de efectivo',
            'user_cash_title': 'Retiro de comisión',
            'user_cash_not_link': 'No tiene enlace e-cartera todavía, por favor enlace y envíe la solicitud de retirada de nuevo.',
            'user_cash_link_now': 'Vincular ahora',
            'user_cash_service_provider': 'Proveedor de servicios',
            'user_cash_select_account': 'Por favor seleccione la cuenta de retirada',
            'user_cash_binance_pay': 'Binance Pago',
            'user_cash_bank_account': 'Cuenta bancaria',
            'user_cash_bank_account_pla': 'Rellene su número de cuenta bancaria',
            'user_cash_ifsc_pla': 'Rellene su número de IFSC cuenta ',
            'user_cash_upi_pla': 'Rellene su número de UPI cuenta ',
            'user_cash_withdraw': 'Retirar',
            'user_cash_minimum': 'Mínimo',
            'user_cash_to_withdraw': 'Para Retirar',
            'user_cash_current_commission': 'Comisión actual disponible para el retiro',
            'user_cash_account': 'Cuenta',
            'user_cash_account_pla': 'Rellene su nombre de usuario de Alipay',
            'user_cash_current_withdrawal': 'Comisión de retirada actual',
            'user_cash_to_e_wallet': 'Retire a E-Cartera',
            'user_cash_to_balance': 'Retirar al saldo',
            'user_cash_insufficient_balance': 'Saldo insuficiente',
            'user_cash_data_format': 'Datos en formato incorrecto'
        },
        'service': {
            'title': 'Registros de mensajes',
            'write_email': 'Por favor, escríbenos por correo electrónico'
        }
    }
};